/**
 * The facility's EHR title (`tblFacility.EHR_Title`) as shown to users.
 *
 * PointClickCare requires its name to be shown exactly as "PointClickCare",
 * so a stored title of "PCC", "Point Click Care", "Point-Click-Care",
 * "Pointclickcare", etc. displays as "PointClickCare". The stored value is
 * not changed (the EHR worker matches note text against it); only the text
 * on screen is. Any other title is returned trimmed; blank returns ''.
 *
 * Mirrors `FacilitySettings.EhrDisplayName` in the shared VB core, which
 * the API and the desktop use for the same purpose.
 */
export function displayEhrTitle(raw: string | null | undefined): string {
  const trimmed = (raw ?? '').trim();
  if (!trimmed) return '';
  const key = trimmed.replace(/[\s_-]/g, '').toLowerCase();
  if (key === 'pcc' || key === 'pointclickcare') return 'PointClickCare';
  return trimmed;
}
